<div class="notification-failed">
<div class="event-item">
    <span class="notification-activity dismiss" (click)="dismiss()">Dismiss</span>
    <div class="header-notification">
      <h3>{{notification.context}}</h3> <strong>FAILED</strong>
    </div>
    <p>The status of the version could NOT be changed,
      please contact your admin for additional support.</p>
</div>
</div>